'use client';

import { useEffect, useState } from 'react';
import { initializeErrorSuppressor } from '../../../lib/console-error-suppressor';

const ErrorSuppressor = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    initializeErrorSuppressor();
  }, []);

  if (!isClient) {
    return null;
  }

  return null;
};

export default ErrorSuppressor;
